module.exports = __webpack_public_path__ + "img/grinder-wooden.42369c4e.jpg";